import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { action } from 'satcheljs';

const initializeAdjacentAndConflictingMeetingsAction = action(
    'initializeAdjacentAndConflictingMeetingsAction',
    (item: CalendarItem, meetingRequestViewState: MeetingRequestViewState) => ({
        item: item,
        meetingRequestViewState: meetingRequestViewState,
    })
);

export default initializeAdjacentAndConflictingMeetingsAction;
